module.exports = __webpack_public_path__ + "static/img/PFK_Golf2.7288628.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_Golf2.jpg
// module id = 327
// module chunks = 2